// import { Injectable } from '@angular/core';
// import { MessageServiceClient } from '../../proto/MessageServiceClientPb';
// import { ClientInfo } from '../../proto/message_pb';
// import { environment } from '../../../environments/environment';

// @Injectable({
//   providedIn: 'root',
// })
// export class GrpcService {
//   // private client = new MessageServiceClient('https://devapi.tradeseel.com:443');
//   private client = new MessageServiceClient(environment.grpcUrl);
//   private stream: any;

//   private isConnected = false;
//   private connectionTimeout: any;

//   private reconnectTimer: ReturnType<typeof setTimeout> | null = null;
//   private currentClientId = '';
//   private currentMessageHandler: ((data: any) => void) | null = null;
//   private manuallyDisconnected = false;
//   private reconnectAttempts = 0;

//   connect(clientId: string, onMessage: (data: any) => void): void {
//     if (!clientId) {
//       console.error('gRPC connection failed: clientId is empty');
//       return;
//     }

//     this.disconnect(false);

//     this.currentClientId = clientId;
//     this.currentMessageHandler = onMessage;
//     this.manuallyDisconnected = false;
//     this.reconnectAttempts = 0;

//     this.openStream();

//     // Remaining connection code...

//     console.log('🚀 gRPC connect() called with clientId:', clientId);

//     const request = new ClientInfo();
//     request.setClientid(clientId);

//     const metadata = {
//       'Api-Key': 'R8QyXfU5ZlPt9VJoMwEcN3B7KsHe4a12gDYvIj0nTqHxSbLrOwFkC6MzEpG',
//     };

//     try {
//       this.stream = this.client.streamMessages(request, metadata);

//       console.log(
//         '🟡 gRPC stream initialized (waiting for server response...)',
//       );

//       // ⏱ fallback success check (important for 204 cases)
//       this.connectionTimeout = setTimeout(() => {
//         if (!this.isConnected) {
//           console.warn('⚠️ gRPC stream opened but no data received yet');
//         }
//       }, 5000);
//     } catch (error) {
//       this.isConnected = false;
//       console.error('❌ gRPC stream init failed:', error);
//       return;
//     }

//     this.stream.on('data', (response: any) => {
//       console.log('📩 Raw gRPC response:', response);

//       // ✅ FIRST REAL SUCCESS CONNECT
//       if (!this.isConnected) {
//         this.isConnected = true;
//         clearTimeout(this.connectionTimeout);

//         console.log('✅ SUCCESS: gRPC CONNECTED AND RECEIVING DATA');
//       }

//       // try {
//       //   const parsed = JSON.parse(response.getJson());
//       //   console.log('🔥 Parsed message:', parsed);

//       //   onMessage(parsed);
//       // } catch (err) {
//       //   console.error('❌ JSON parse error:', err);
//       // }

//       try {
//         const rawMessage = response.getJson();

//         const parsed = this.parseGrpcMessage(rawMessage);

//         console.log('🔥 Parsed gRPC message:', parsed);

//         onMessage(parsed);
//       } catch (err) {
//         console.error('❌ gRPC message parse error:', err);
//       }
//     });

//     this.stream.on('error', (err: any) => {
//       this.isConnected = false;
//       clearTimeout(this.connectionTimeout);

//       console.error('❌ gRPC ERROR:', err);
//     });

//     this.stream.on('end', () => {
//       this.isConnected = false;
//       clearTimeout(this.connectionTimeout);

//       console.warn('⚠️ gRPC stream ended');
//     });
//   }

//   private openStream(): void {
//     if (!this.currentClientId || !this.currentMessageHandler) {
//       return;
//     }

//     const request = new ClientInfo();
//     request.setClientid(this.currentClientId);

//     const metadata = {
//       'Api-Key': 'R8QyXfU5ZlPt9VJoMwEcN3B7KsHe4a12gDYvIj0nTqHxSbLrOwFkC6MzEpG',
//     };

//     console.log('🚀 Opening gRPC stream for:', this.currentClientId);

//     try {
//       this.stream = this.client.streamMessages(request, metadata);
//     } catch (error) {
//       console.error('❌ Unable to initialize gRPC stream:', error);
//       this.scheduleReconnect();
//       return;
//     }

//     this.connectionTimeout = setTimeout(() => {
//       if (!this.isConnected) {
//         console.warn('gRPC opened, but no response has been received');
//       }
//     }, 5000);

//     this.stream.on('data', (response: any) => {
//       if (!this.isConnected) {
//         this.isConnected = true;
//         this.reconnectAttempts = 0;

//         if (this.connectionTimeout) {
//           clearTimeout(this.connectionTimeout);
//         }

//         console.log('✅ gRPC connected');
//       }

//       try {
//         const parsed = this.parseGrpcMessage(response.getJson());

//         if (parsed) {
//           this.currentMessageHandler?.(parsed);
//         }
//       } catch (error) {
//         console.error('❌ gRPC message processing error:', error);
//       }
//     });

//     this.stream.on('error', (error: any) => {
//       this.isConnected = false;

//       if (this.connectionTimeout) {
//         clearTimeout(this.connectionTimeout);
//       }

//       console.error('❌ gRPC stream error:', error);

//       if (!this.manuallyDisconnected) {
//         this.scheduleReconnect();
//       }
//     });

//     this.stream.on('end', () => {
//       this.isConnected = false;

//       if (this.connectionTimeout) {
//         clearTimeout(this.connectionTimeout);
//       }

//       console.warn('⚠️ gRPC stream ended');

//       if (!this.manuallyDisconnected) {
//         this.scheduleReconnect();
//       }
//     });
//   }

//   private scheduleReconnect(): void {
//     if (this.manuallyDisconnected || this.reconnectTimer) {
//       return;
//     }

//     const delay = Math.min(3000 * Math.pow(2, this.reconnectAttempts), 30000);

//     this.reconnectAttempts++;

//     console.log(`Reconnecting gRPC in ${delay / 1000} seconds`);

//     this.reconnectTimer = setTimeout(() => {
//       this.reconnectTimer = null;
//       this.openStream();
//     }, delay);
//   }

//   private parseGrpcMessage(rawMessage: string): any {
//     if (!rawMessage) {
//       return null;
//     }

//     // First try normal JSON.
//     try {
//       return JSON.parse(rawMessage);
//     } catch {
//       // Continue with backend's tilde-separated format.
//     }

//     const parts = rawMessage.split('~');

//     if (parts.length >= 5) {
//       const transactionType = parts[0];
//       const printerType = parts[1];
//       const printCopy = parts[2];
//       const createdDate = parts[3];

//       // Join remaining sections in case JSON data itself contains "~".
//       const jsonContent = parts.slice(4).join('~');

//       let data: any = jsonContent;

//       try {
//         data = JSON.parse(jsonContent);
//       } catch {
//         console.warn('gRPC payload data is not valid JSON:', jsonContent);
//       }

//       return {
//         type: transactionType,
//         transactionType,
//         printerType,
//         printCopy,
//         createdDate,
//         data,
//         rawMessage,
//       };
//     }

//     return {
//       type: 'UNKNOWN',
//       data: rawMessage,
//       rawMessage,
//     };
//   }

//   // disconnect(): void {
//   //   console.log('🔌 gRPC disconnect called');

//   //   if (this.stream) {
//   //     this.stream.cancel();
//   //     this.isConnected = false;
//   //     console.log('🛑 gRPC disconnected');
//   //   }
//   // }

//   // disconnect(showLog: boolean = true): void {
//   //   if (this.connectionTimeout) {
//   //     clearTimeout(this.connectionTimeout);
//   //     this.connectionTimeout = null;
//   //   }

//   //   if (this.stream) {
//   //     this.stream.cancel();
//   //     this.stream = null;
//   //   }

//   //   this.isConnected = false;

//   //   if (showLog) {
//   //     console.log('🛑 gRPC disconnected');
//   //   }
//   // }

//   // getConnectionStatus(): boolean {
//   //   return this.isConnected;
//   // }

//   disconnect(showLog: boolean = true): void {
//     this.manuallyDisconnected = true;

//     if (this.reconnectTimer) {
//       clearTimeout(this.reconnectTimer);
//       this.reconnectTimer = null;
//     }

//     if (this.connectionTimeout) {
//       clearTimeout(this.connectionTimeout);
//       this.connectionTimeout = null;
//     }

//     if (this.stream) {
//       this.stream.cancel();
//       this.stream = null;
//     }

//     this.isConnected = false;

//     if (showLog) {
//       console.log('🛑 gRPC disconnected');
//     }
//   }
// }

// --------------------------------------------------

import { Injectable } from '@angular/core';
import { MessageServiceClient } from '../../proto/MessageServiceClientPb';
import { ClientInfo } from '../../proto/message_pb';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GrpcService {
  private client = new MessageServiceClient(environment.grpcUrl);

  private stream: any;

  private isConnected = false;
  private connectionTimeout: ReturnType<typeof setTimeout> | null = null;
  private reconnectTimer: ReturnType<typeof setTimeout> | null = null;

  private currentClientId = '';
  private currentMessageHandler: ((data: any) => void) | null = null;

  private manuallyDisconnected = false;
  private reconnectAttempts = 0;

  connect(clientId: string, onMessage: (data: any) => void): void {
    if (!clientId?.trim()) {
      console.error('gRPC connection failed: clientId/storeCode is empty');
      return;
    }

    this.disconnect(false);

    this.currentClientId = clientId.trim();
    this.currentMessageHandler = onMessage;
    this.manuallyDisconnected = false;
    this.reconnectAttempts = 0;

    this.openStream();
  }

  private openStream(): void {
    if (!this.currentClientId || !this.currentMessageHandler) {
      return;
    }

    const request = new ClientInfo();
    request.setClientid(this.currentClientId);

    const metadata = {
      'Api-Key': 'R8QyXfU5ZlPt9VJoMwEcN3B7KsHe4a12gDYvIj0nTqHxSbLrOwFkC6MzEpG',
    };

    console.log('🚀 Opening gRPC connection:', this.currentClientId);

    try {
      this.stream = this.client.streamMessages(request, metadata);
    } catch (error) {
      console.error('❌ gRPC stream initialization failed:', error);

      this.scheduleReconnect();
      return;
    }

    this.connectionTimeout = setTimeout(() => {
      if (!this.isConnected) {
        console.warn('⚠️ gRPC opened but no server response received');
      }
    }, 5000);

    this.stream.on('data', (response: any) => {
      if (!this.isConnected) {
        this.isConnected = true;
        this.reconnectAttempts = 0;

        if (this.connectionTimeout) {
          clearTimeout(this.connectionTimeout);
          this.connectionTimeout = null;
        }

        console.log('✅ gRPC connected');
      }

      try {
        const rawMessage = response.getJson();

        console.log('📩 Raw gRPC message:', rawMessage);

        const parsed = this.parseGrpcMessage(rawMessage);

        if (parsed) {
          this.currentMessageHandler?.(parsed);
        }
      } catch (error) {
        console.error('❌ gRPC message handling failed:', error);
      }
    });

    this.stream.on('error', (error: any) => {
      this.isConnected = false;

      console.error('❌ gRPC error:', error);

      if (!this.manuallyDisconnected) {
        this.scheduleReconnect();
      }
    });

    this.stream.on('end', () => {
      this.isConnected = false;

      console.warn('⚠️ gRPC stream ended');

      if (!this.manuallyDisconnected) {
        this.scheduleReconnect();
      }
    });
  }

  private parseGrpcMessage(rawMessage: string): any {
    if (!rawMessage) {
      return null;
    }

    try {
      return JSON.parse(rawMessage);
    } catch {
      // Backend also sends "~" separated messages.
    }

    const parts = rawMessage.split('~');

    if (parts.length >= 5) {
      const jsonContent = parts.slice(4).join('~');

      let data: any = jsonContent;

      try {
        data = JSON.parse(jsonContent);
      } catch {
        console.warn('Payload section is not valid JSON:', jsonContent);
      }

      return {
        type: parts[0],
        transactionType: parts[0],
        printerType: parts[1],
        printCopy: parts[2],
        createdDate: parts[3],
        data,
        rawMessage,
      };
    }

    return {
      type: 'UNKNOWN',
      data: rawMessage,
      rawMessage,
    };
  }

  private scheduleReconnect(): void {
    if (this.manuallyDisconnected || this.reconnectTimer) {
      return;
    }

    const delay = Math.min(3000 * Math.pow(2, this.reconnectAttempts), 30000);

    this.reconnectAttempts++;

    console.log(`🔄 Reconnecting gRPC in ${delay / 1000} seconds`);

    this.reconnectTimer = setTimeout(() => {
      this.reconnectTimer = null;
      this.openStream();
    }, delay);
  }

  disconnect(showLog: boolean = true): void {
    this.manuallyDisconnected = true;

    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer);
      this.reconnectTimer = null;
    }

    if (this.connectionTimeout) {
      clearTimeout(this.connectionTimeout);
      this.connectionTimeout = null;
    }

    if (this.stream) {
      this.stream.cancel();
      this.stream = null;
    }

    this.isConnected = false;

    if (showLog) {
      console.log('🛑 gRPC disconnected');
    }
  }

  getConnectionStatus(): boolean {
    return this.isConnected;
  }
}
